import { render, staticRenderFns } from "./download-and-more.vue?vue&type=template&id=ca0e672e"
import script from "./download-and-more.vue?vue&type=script&lang=js"
export * from "./download-and-more.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TfImg: require('/usr/src/app/components/tf/img.vue').default})
